import { SxProps, Theme } from '@mui/material';

export const AccountSummaryCardPointsFrameSX: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'space-between',
	flexDirection: { xs: 'column', md: 'row' },
	gap: 1,
	width: { xs: '100%', md: '549px' },
	backgroundColor: '#FFFFFF',
	border: '1px solid #ECECEC',
	borderRadius: '5px',
	paddingX: { xs: 0, md: 1 },
	paddingY: { xs: 1.5, md: 2 },
};

export const AccountSummaryCardPointsContentSX: SxProps<Theme> = {
	paddingX: 2,
};

export const AccountSummaryCardPointsLabelSX: SxProps<Theme> = ({
	color: '#707070',
	fontSize: 'var(--font-size-small)',
});

export const AccountSummaryCardPointsValueSX =
	(isRewards: boolean): SxProps<Theme> =>
	({
		display: 'flex',
		alignItems: 'center',
		fontSize: 'var(--font-size-lg)',
		color: isRewards ? '#0467D2' : '#D20D48',
		fontWeight: 'bold',
		gap: 0.5,
	});

export const AccountSummaryCardPointsIconSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-xl)',
});

export const AccountSummaryCardPointsDividerHorizontalSX: SxProps<Theme> = {
	display: { xs: 'block', md: 'none' },
};

export const AccountSummaryCardPointsDividerVerticalSX: SxProps<Theme> = {
	display: { xs: 'none', md: 'block' },
};

export const AccountSummaryCardPointsCardSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-body)',
	color: '#333333',
	fontWeight: 600,
	display: 'flex',
	gap: 1,
});

export const AccountSummaryCardPointsButtonBaseSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
});
